import { ApiError } from '@gorila-shared-ui/components';
import { Brand } from '../types/brand';
import { SubBrand } from '../types/subBrand';
import { Version } from '../types/version';
import { getRequest } from './api';
import { vehiclesBrandsUrl, vehiclesSubBrandsUrl, vehiclesVersionsUrl } from './urls/vehicleUrls';

export const getVehicleBrandsList = async ({
  clientId,
  subClientId,
  page = 1,
  search = '',
}: {
  clientId: string;
  subClientId?: string;
  page?: number;
  search?: string;
}): Promise<{ brands?: Brand[]; error?: ApiError; total: number; hasNext: boolean }> => {
  const queryParams = {
    clientId,
    subClientId,
    page,
    search,
  };
  const response = await getRequest(vehiclesBrandsUrl, {
    queryParams,
  });
  return {
    brands: response?.data?.items,
    total: response?.data?.total ?? 0,
    hasNext: response?.data?.hasNext ?? false,
    error: response?.error,
  };
};

export const getVehicleSubBrandsList = async ({
  clientId,
  subClientId,
  page = 1,
  search = '',
  brandId,
}: {
  clientId: string;
  subClientId?: string;
  page?: number;
  search?: string;
  brandId?: string;
}): Promise<{ subBrands?: SubBrand[]; error?: ApiError; total: number; hasNext: boolean }> => {
  const queryParams = {
    clientId,
    subClientId,
    page: page ?? 1,
    search,
    brandId,
  };
  const response = await getRequest(vehiclesSubBrandsUrl, {
    queryParams,
  });
  return {
    subBrands: response?.data?.items,
    total: response?.data?.total ?? 0,
    hasNext: response?.data?.hasNext ?? false,
    error: response?.error,
  };
};

export const getVersionsList = async ({
  clientId,
  subClientId,
  page,
  search,
  brandId,
  subBrandId,
}: {
  clientId: string;
  subClientId?: string;
  page?: number;
  search?: string;
  brandId?: string;
  subBrandId?: string;
}): Promise<{ versions?: Version[]; error?: ApiError; total: number; hasNext: boolean }> => {
  const queryParams = {
    clientId,
    subClientId,
    page: page ?? 1,
    search,
    brandId,
    subBrandId,
  };
  const response = await getRequest(vehiclesVersionsUrl, {
    queryParams,
  });
  return {
    versions: response?.data?.items,
    total: response?.data?.total ?? 0,
    hasNext: response?.data?.hasNext ?? false,
    error: response?.error,
  };
};
